import { deleteMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_LOCATION = 'DELETE_LOCATION';
export const DELETE_LOCATION_SUCCESS = 'DELETE_LOCATION_SUCCESS';
export const DELETE_LOCATION_FAILURE = 'DELETE_LOCATION_FAILURE';

// Action Creators
export const deleteLocation = () => ({
  type: DELETE_LOCATION,
});

export const deleteLocationSuccess = (data) => ({
  type: DELETE_LOCATION_SUCCESS,
  payload: data,
});

export const deleteLocationFailure = (error) => ({
  type: DELETE_LOCATION_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteLocationCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(deleteLocation());
    try {
      const response = await deleteMethodWithToken(
        url.staff + data?.enterpriseId + '/locations/' + data?.id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(deleteLocationSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(deleteLocationFailure(response?.data));
      }
    } catch (error) {
      dispatch(deleteLocationFailure(error?.message));
    }
  };
};
